module.exports = __webpack_public_path__ + "img/meter_74x194.aa5bc951.png";